import React from 'react';

import classnames from 'classnames';

import cls from './tooltip.module.css';

interface ITooltipProps {
    children?: React.ReactNode;
    textContent?: string;
    classes?: string;
}

export const Tooltip = ({ children, textContent, classes = '' }: ITooltipProps) => (
    <span className={classnames(cls.tooltip, [classes])}>{children || textContent}</span>
);
